
































































































import Vue from 'vue'
import Component from 'vue-class-component'
import User from '@/provider/user'
import CircularLoading from '@/components/Loading/CircularLoading.vue'

@Component({
  components: {
    CircularLoading
  }
})
export default class ATWorksheet extends Vue {
  loading: boolean = true
  userId: string = ''
  userProvider!: User
  worksheetData: Array<any> = []

  async beforeMount () {
    this.userId = this.$route.params.userId
    this.userProvider = new User(this.userId)
    this.userProvider.getWorksheet('AT').then((result) => {
      this.worksheetData = result
      this.loading = false
    })
  }

  get worksheetCount () {
    return this.loading ? '' : this.worksheetData.length
  }

  getStringFromKey (key: string, values: {[key:string]:string}) {
    let value = values[key]
    return value || '不明'
  }

  onCheckValues: {[key:string]:string} = {
    'YES': 'はい',
    'NO': 'いいえ'
  }

  onStepValues: {[key:string]:string} = {
    '0': '未入力',
    '1': '初回で入力完了',
    '2': '1回目ヒント後、入力完了',
    '3': '書き直しで入力完了',
    '4': '2回目ヒント後、入力完了'
  }

  proposalStepValues: {[key:string]:string} = {
    '0': '未入力完了',
    '1': '初回で入力完了',
    '2': '1回目ヒント後、入力完了'
  }

  valuetaionValues: {[key:string]:string} = {
    '1': 'おおいに改善の余地がある',
    '2': '少し改善の余地がある',
    '3': '普通',
    '4': 'まぁまぁ良くなった',
    '5': 'とても良くなった'

  }
}
